module.exports = __webpack_public_path__ + "static/media/20210403_215015_115_IMG_0059.34e3abe8.jpg";